import { render, staticRenderFns } from "./ItemsInfo.vue?vue&type=template&id=1f68531d&"
import script from "./ItemsInfo.vue?vue&type=script&lang=js&"
export * from "./ItemsInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports